import { FC } from 'react';
import Header from 'app/components/Header';
import Box from '@mui/material/Box';
import ReserveDates from 'app/components/ReserveDates';
import useScrollTop from 'app/hooks/useScrollTop';
import StrollerList from '../StrollerList';
import castleBg from 'assets/images/castle-bg-mobile.jpg';

export interface StrollerGroup {
  type: number;
  key: string;
  name: string;
}

const StrollerListMobile: FC = () => {
  useScrollTop(true);

  return (
    <>
      <Box
        minHeight="100vh"
        width="100vw"
        display="flex"
        flexDirection="column"
        pb={4}
      >
        <Header backButton />

        <Box
          display="flex"
          justifyContent="center"
          py={5}
          px={15}
          sx={{
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundImage: `url('${castleBg}')`,
            '@media (max-width: 1100px)': {
              px: 2,
            },
          }}
        >
          <ReserveDates hideTitle />
        </Box>

        <StrollerList />
      </Box>
    </>
  );
};

export default StrollerListMobile;
